export enum AxnAdminUserPropertyBundleTypes {
    RP = "RP",
    ORGANIZATION = "ORGANIZATION"
}